// PRODUCCION
export const idAnalytics = 'G-7XCKGK5MQZ';
export const apiKeyGoogleMap = 'AIzaSyAv4-L5EAusz7jUx09wb8IHNC28drRigTo';

// QA
// export const idAnalytics = 'G-HSB4DQV1L9';
// export const apiKeyGoogleMap = 'AIzaSyBG7m3bd-nWXPyCyN8OiQGNK7clYvxFHn4';
